import { useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

type UserRole = 'admin' | 'partner' | 'customer' | null;

export function useAuthRole() {
  const [userRole, setUserRole] = useState<UserRole>(null);

  const fetchUserRole = useCallback(async (userId: string) => {
    try {
      // First check if user has a direct role
      const { data: roleData, error: roleError } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', userId)
        .maybeSingle();
      
      if (roleData && !roleError) {
        setUserRole(roleData.role as UserRole);
        return;
      }

      // If no direct role, check if user is an employee of a partner
      const { data: profileData } = await supabase
        .from('profiles')
        .select('parent_user_id')
        .eq('user_id', userId)
        .single();

      if (profileData?.parent_user_id) {
        // Check if parent has partner role
        const { data: parentRoleData } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', profileData.parent_user_id)
          .maybeSingle();

        if (parentRoleData?.role === 'partner') {
          setUserRole('partner');
          return;
        }
      }

      setUserRole(null);
    } catch (error) {
      console.error('[useAuthRole] Error fetching role:', error);
      setUserRole(null);
    }
  }, []);

  return { userRole, fetchUserRole };
}
